// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mLXV","colBig":"styles_colBig__3CT5M","colSmall":"styles_colSmall__3W1Ej","shopifyNameWrapper":"styles_shopifyNameWrapper__Oitr6"};